/**
* Enums.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2019
*/
export var AuthType = {
    NONE: 0,
    MSA: 1,
    AAD: 2
};
//# sourceMappingURL=Enums.js.map